// extracted by mini-css-extract-plugin
module.exports =  {"container":"a10a3f92e9--container--o9T5Q","text":"a10a3f92e9--text--qaKz7"};